import { gql } from "@apollo/client";

export const AGREGAR_CONEXIONES = gql`
mutation agregarConexionesFueraDeCierre($mes: Int!, $anio: Int!) {
    agregarConexionesFueraDeCierre(mes: $mes, anio: $anio) {
        success
        valorEsperado
        error
    }
}`;